/* NVZN3D TRUEVIEW AR JAVASCRIPT */

(function () {

  const nvznAppData = JSON.parse(document.getElementById('nvzn3d-trueview-data').textContent);
  if (!nvznAppData) return console.error('[NVZN] nvzn3d-trueview-data not found');
  log('nvzn3d-trueview-data:', nvznAppData);

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    document.querySelectorAll('.nvzn3d-arbutton').forEach((button) => {
      button.addEventListener('click', function () {

        const dimensions = extractDimensions(nvznAppData.product.arDimensions);
        log('dimensions:', dimensions);
        log('arImage:', nvznAppData.product.arImage);

        let options = {
          clientID: nvznAppData.app.clientID,
          width: dimensions.width,
          length: dimensions.length,
          units: dimensions.units,
          imageUrl: nvznAppData.product.arImage,
          shape: 'rectangle',
        };

        displayPreview(options);

      });
    });
  }

  function displayPreview(options) {
    log('displayPreview', options);
    Nvzn3D.displayFloorPreview({
      clientId: options.clientID,
      width: options.width,
      length: options.length,
      units: options.units,
      imageUrl: options.imageUrl,
    });
  }


  function extractDimensions(sizeString) {
    if (!sizeString || typeof sizeString !== 'string') return null;

    // Matches: <number> [spaces] [x|X|×] [spaces] <number> [spaces] [units]
    const regex = /^\s*(\d+(?:\.\d+)?)\s*(?:[xX×])\s*(\d+(?:\.\d+)?)\s*([a-zA-Z"']+)?\s*$/;
    const match = sizeString.trim().match(regex);

    if (!match) return null;

    return {
      width: parseFloat(match[1]),
      length: parseFloat(match[2]),
      units: match[3] ? match[3].toLowerCase() : 'cm'
    };
  }


  function log(...args) {
    if (nvznAppData.app && nvznAppData.app.logging) {
      console.log('[NVZN]', ...args);
    }
  }

  init();
})();